<template>
    <div>
        <h4>แสดงราคา +บาทของสินค้า</h4>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">เลือกประเภทสินค้า</div>
            <div class="col-6">
                <b-form-select :options="optionProductType" v-model="form.product_type_id">
                </b-form-select>
            </div>
        </div>
        <template v-if="form.product_type_id == 1">
            <div class="row form-group" >
                <div class="col-4 text-right">
                    <label>+บาทโฟม</label>
                </div>
                <div class="col-6">
                    <b-form-select :options="add_foam" v-model="form.add_price_foam">
                    </b-form-select>
                </div>
            </div>
            <div class="row form-group" >
                <div class="col-4 text-right">
                    <label>-บาทโฟม</label>
                </div>
                <div class="col-6">
                    <b-form-select :options="reduce_foam" v-model="form.reduce_price_foam">
                    </b-form-select>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row form-group" v-if="form.product_type_id">
                <div class="col-4 text-right">
                    <label>+บาทอื่นๆ(ลัง)</label>
                </div>
                <div class="col-6">
                    <b-form-select :options="add_price_other" v-model="form.add_price_other">
                    </b-form-select>
                </div>
            </div>
            <div class="row form-group" v-if="form.product_type_id">
                <div class="col-4 text-right">
                    <label>-บาทอื่นๆ</label>
                </div>
                <div class="col-6">
                    <b-form-select :options="reduce_price_other" v-model="form.reduce_price_other">
                    </b-form-select>
                </div>
            </div>
        </template>
        <div class="col text-center">
            <button
                class="btn btn-success mb-3"
                @click="confirmOrder"
                style="margin-right: 20px">
                <icon name="save"></icon> บันทึก
            </button>
            <button
                class="btn btn btn-outline-secondary mr-1 mb-3"
                @click="closeModal">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "AddPriceForTypeModal",
        created() {
            this.$store.dispatch("ProductType/get")
        },
        computed: {
            ...mapState({
                optionProductType: state => {
                    return [
                        {
                            value: '',
                            text: "ประเภทสินค้า"
                        },
                        ...state.ProductType.data.map(data => ({
                            value: data.id,
                            text: data.name
                        }))
                    ];
                },
            })
        },
        data(){
            return {
                add_foam : [
                    {value:'',text:'เลือก +บาทโฟม'},
                    {value:1,text :'+1'},
                    {value:2,text :'+2'},
                    {value:3,text :'+3'},
                    {value:4,text :'+4'},
                    {value:5,text :'+5'},
                ],
                reduce_foam : [
                    {value:'',text:'เลือก -บาทโฟม'},
                    {value:1,text :'-1'},
                    {value:2,text :'-2'},
                    {value:3,text :'-3'},
                    {value:4,text :'-4'},
                    {value:5,text :'-5'},
                ],
                add_price_other : [
                    {value:'',text:'เลือก +บาท(ลัง)'},
                    {value:1,text :'+10'},
                    {value:2,text :'+20'},
                    {value:3,text :'+30'},
                    {value:4,text :'+40'},
                    {value:5,text :'+50'},
                ],
                reduce_price_other : [
                    {value:'',text:'เลือก -บาท(ลัง)'},
                    {value:1,text :'-10'},
                    {value:2,text :'-20'},
                    {value:3,text :'-30'},
                    {value:4,text :'-40'},
                    {value:5,text :'-50'},
                ],
                form : {
                    product_type_id : '',
                    add_price_foam : '',
                    add_price_other : '',
                    reduce_price_foam : '',
                    reduce_price_other : '',
                }
            }
        },
        methods:{
            confirmOrder(){
                this.$emit('submit',this.form);
            },
            closeModal(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>
